import { render, staticRenderFns } from "./platformManagementList.vue?vue&type=template&id=4ea0cb19"
import script from "./platformManagementList.vue?vue&type=script&lang=js"
export * from "./platformManagementList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports